var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImagePlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 37 37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{isolation:isolate;}.cls-4{clip-path:url(#clip-path-2);}.cls-5{clip-path:url(#clip-path-3);}.cls-6{clip-path:url(#clip-path-4);}.cls-7{clip-path:url(#clip-path-5);}.cls-8{clip-path:url(#clip-path-6);}.cls-9{clip-path:url(#clip-path-7);}.cls-10{clip-path:url(#clip-path-8);}.cls-11{clip-path:url(#clip-path-9);}.cls-12{clip-path:url(#clip-path-10);}.cls-13{clip-path:url(#clip-path-11);}.cls-14{clip-path:url(#clip-path-12);}.cls-15{clip-path:url(#clip-path-13);}.cls-16{clip-path:url(#clip-path-14);}.cls-17{clip-path:url(#clip-path-15);}.cls-18{clip-path:url(#clip-path-16);}.cls-19{clip-path:url(#clip-path-17);}.cls-20{clip-path:url(#clip-path-18);}.cls-21{clip-path:url(#clip-path-19);}.cls-22{clip-path:url(#clip-path-20);}.cls-23{clip-path:url(#clip-path-21);}.cls-24{clip-path:url(#clip-path-22);}.cls-25{clip-path:url(#clip-path-23);}.cls-26{clip-path:url(#clip-path-24);}.cls-27{clip-path:url(#clip-path-25);}.cls-28{clip-path:url(#clip-path-26);}.cls-29{clip-path:url(#clip-path-27);}.cls-30{clip-path:url(#clip-path-28);}.cls-31{clip-path:url(#clip-path-29);}.cls-32{clip-path:url(#clip-path-30);}.cls-33{clip-path:url(#clip-path-31);}.cls-34{clip-path:url(#clip-path-32);}.cls-35{clip-path:url(#clip-path-33);}.cls-36{clip-path:url(#clip-path-34);}.cls-37{clip-path:url(#clip-path-35);}.cls-38{clip-path:url(#clip-path-36);}.cls-39{clip-path:url(#clip-path-37);}.cls-40{clip-path:url(#clip-path-38);}.cls-41{clip-path:url(#clip-path-39);}.cls-42{clip-path:url(#clip-path-40);}.cls-43{clip-path:url(#clip-path-41);}.cls-44{clip-path:url(#clip-path-42);}.cls-45{clip-path:url(#clip-path-43);}.cls-46{clip-path:url(#clip-path-44);}.cls-47{clip-path:url(#clip-path-45);}.cls-48{clip-path:url(#clip-path-46);}.cls-49{clip-path:url(#clip-path-47);}.cls-50{clip-path:url(#clip-path-48);}.cls-51{clip-path:url(#clip-path-49);}.cls-52{clip-path:url(#clip-path-50);}.cls-53{clip-path:url(#clip-path-51);}.cls-54{clip-path:url(#clip-path-52);}.cls-55{clip-path:url(#clip-path-53);}.cls-56{clip-path:url(#clip-path-54);}.cls-57{clip-path:url(#clip-path-55);}.cls-58{clip-path:url(#clip-path-56);}.cls-59{clip-path:url(#clip-path-57);}.cls-60{clip-path:url(#clip-path-58);}.cls-61{clip-path:url(#clip-path-59);}.cls-62{clip-path:url(#clip-path-60);}.cls-63{clip-path:url(#clip-path-61);}.cls-64{clip-path:url(#clip-path-62);}.cls-65{clip-path:url(#clip-path-63);}.cls-66{clip-path:url(#clip-path-64);}.cls-67{clip-path:url(#clip-path-65);}.cls-68{clip-path:url(#clip-path-66);}.cls-69{clip-path:url(#clip-path-67);}.cls-70{clip-path:url(#clip-path-68);}.cls-71{clip-path:url(#clip-path-69);}.cls-72{clip-path:url(#clip-path-70);}.cls-73{clip-path:url(#clip-path-71);}.cls-74{clip-path:url(#clip-path-72);}.cls-75{clip-path:url(#clip-path-73);}.cls-76{clip-path:url(#clip-path-74);}.cls-77{clip-path:url(#clip-path-75);}.cls-78{clip-path:url(#clip-path-76);}.cls-79{clip-path:url(#clip-path-77);}.cls-80{clip-path:url(#clip-path-78);}.cls-81{clip-path:url(#clip-path-79);}.cls-82{clip-path:url(#clip-path-80);}.cls-83{clip-path:url(#clip-path-81);}.cls-84{clip-path:url(#clip-path-82);}.cls-85{clip-path:url(#clip-path-83);}.cls-86{clip-path:url(#clip-path-84);}.cls-87{clip-path:url(#clip-path-85);}.cls-88{clip-path:url(#clip-path-86);}.cls-89{clip-path:url(#clip-path-87);}.cls-90{clip-path:url(#clip-path-88);}.cls-91{clip-path:url(#clip-path-89);}.cls-92{clip-path:url(#clip-path-90);}.cls-93{clip-path:url(#clip-path-91);}.cls-94{clip-path:url(#clip-path-92);}.cls-95{clip-path:url(#clip-path-93);}.cls-96{clip-path:url(#clip-path-94);}.cls-97{clip-path:url(#clip-path-95);}.cls-98{clip-path:url(#clip-path-96);}.cls-99{clip-path:url(#clip-path-97);}.cls-100{clip-path:url(#clip-path-98);}.cls-101{clip-path:url(#clip-path-99);}.cls-102{clip-path:url(#clip-path-100);}.cls-103{clip-path:url(#clip-path-101);}.cls-104{clip-path:url(#clip-path-102);}.cls-105{clip-path:url(#clip-path-103);}.cls-106{clip-path:url(#clip-path-104);}.cls-107{clip-path:url(#clip-path-105);}.cls-108{clip-path:url(#clip-path-106);}.cls-109{clip-path:url(#clip-path-107);}.cls-110{clip-path:url(#clip-path-108);}.cls-111{clip-path:url(#clip-path-109);}.cls-112{clip-path:url(#clip-path-110);}.cls-113{clip-path:url(#clip-path-111);}.cls-114{clip-path:url(#clip-path-112);}.cls-115{clip-path:url(#clip-path-113);}.cls-116{clip-path:url(#clip-path-114);}.cls-117{clip-path:url(#clip-path-115);}.cls-118{clip-path:url(#clip-path-116);}.cls-119{clip-path:url(#clip-path-117);}.cls-120{clip-path:url(#clip-path-118);}.cls-121{clip-path:url(#clip-path-119);}.cls-122{clip-path:url(#clip-path-120);}.cls-123{clip-path:url(#clip-path-121);}.cls-124{clip-path:url(#clip-path-122);}.cls-125{clip-path:url(#clip-path-123);}.cls-126{clip-path:url(#clip-path-124);}.cls-127{clip-path:url(#clip-path-125);}.cls-128{clip-path:url(#clip-path-126);}.cls-129{clip-path:url(#clip-path-127);}.cls-130{clip-path:url(#clip-path-128);}.cls-131{clip-path:url(#clip-path-129);}.cls-132{clip-path:url(#clip-path-130);}.cls-133{clip-path:url(#clip-path-131);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: -338.13,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 610.67,
    y: -338.13,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 305.33,
    y: -338.13,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 916,
    y: -338.13,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1221.34,
    y: -338.13,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 152.67,
    y: -338.13,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 763.34,
    y: -338.13,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 458,
    y: -338.13,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1068.67,
    y: -338.13,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1374,
    y: -338.13,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: -112.71,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 610.67,
    y: -112.71,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 305.33,
    y: -112.71,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 916,
    y: -112.71,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1221.34,
    y: -112.71,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 152.67,
    y: -112.71,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 763.34,
    y: -112.71,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 458,
    y: -112.71,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1068.67,
    y: -112.71,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1374,
    y: -112.71,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 112.71,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 610.67,
    y: 112.71,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-23"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 305.33,
    y: 112.71,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-24"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 916,
    y: 112.71,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-25"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1221.34,
    y: 112.71,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-26"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 152.67,
    y: 112.71,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-27"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 763.34,
    y: 112.71,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-28"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 458,
    y: 112.71,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-29"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1068.67,
    y: 112.71,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-30"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1374,
    y: 112.71,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-31"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: -225.42,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-32"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 610.67,
    y: -225.42,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-33"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 305.33,
    y: -225.42,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-34"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 916,
    y: -225.42,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-35"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1221.34,
    y: -225.42,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-36"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 152.67,
    y: -225.42,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-37"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 763.34,
    y: -225.42,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-38"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 458,
    y: -225.42,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-39"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1068.67,
    y: -225.42,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-40"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1374,
    y: -225.42,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-41"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-42"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -33123.33,
    y: -32236.29,
    width: 65535,
    height: 65535
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-43"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 610.67,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-44"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 305.33,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-45"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 916,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-46"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1221.34,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-47"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 152.67,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-48"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 763.34,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-49"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 458,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-50"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1068.67,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-51"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1374,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-52"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 225.42,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-53"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 610.67,
    y: 225.42,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-54"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 305.33,
    y: 225.42,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-55"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 916,
    y: 225.42,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-56"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1221.34,
    y: 225.42,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-57"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 152.67,
    y: 225.42,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-58"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 763.34,
    y: 225.42,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-59"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 458,
    y: 225.42,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-60"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1068.67,
    y: 225.42,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-61"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1374,
    y: 225.42,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-62"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: -281.77,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-63"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 610.67,
    y: -281.77,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-64"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 305.33,
    y: -281.77,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-65"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 916,
    y: -281.77,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-66"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1221.34,
    y: -281.77,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-67"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 152.67,
    y: -281.77,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-68"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 763.34,
    y: -281.77,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-69"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 458,
    y: -281.77,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-70"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1068.67,
    y: -281.77,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-71"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1374,
    y: -281.77,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-72"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: -56.35,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-73"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 610.67,
    y: -56.35,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-74"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 305.33,
    y: -56.35,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-75"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 916,
    y: -56.35,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-76"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1221.34,
    y: -56.35,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-77"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 152.67,
    y: -56.35,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-78"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 763.34,
    y: -56.35,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-79"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 458,
    y: -56.35,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-80"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1068.67,
    y: -56.35,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-81"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1374,
    y: -56.35,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-82"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 169.06,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-83"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 610.67,
    y: 169.06,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-84"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 305.33,
    y: 169.06,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-85"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 916,
    y: 169.06,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-86"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1221.34,
    y: 169.06,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-87"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 152.67,
    y: 169.06,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-88"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 763.34,
    y: 169.06,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-89"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 458,
    y: 169.06,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-90"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1068.67,
    y: 169.06,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-91"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1374,
    y: 169.06,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-92"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: -169.06,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-93"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 610.67,
    y: -169.06,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-94"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 305.33,
    y: -169.06,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-95"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 916,
    y: -169.06,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-96"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1221.34,
    y: -169.06,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-97"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 152.67,
    y: -169.06,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-98"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 763.34,
    y: -169.06,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-99"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 458,
    y: -169.06,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-100"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1068.67,
    y: -169.06,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-101"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1374,
    y: -169.06,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-102"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 56.35,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-103"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 610.67,
    y: 56.35,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-104"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 305.33,
    y: 56.35,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-105"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 916,
    y: 56.35,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-106"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1221.34,
    y: 56.35,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-107"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 152.67,
    y: 56.35,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-108"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 763.34,
    y: 56.35,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-109"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 458,
    y: 56.35,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-110"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1068.67,
    y: 56.35,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-111"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1374,
    y: 56.35,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-112"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 281.77,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-113"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 610.67,
    y: 281.77,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-114"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 305.33,
    y: 281.77,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-115"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 916,
    y: 281.77,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-116"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1221.34,
    y: 281.77,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-117"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 152.67,
    y: 281.77,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-118"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 763.34,
    y: 281.77,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-119"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 458,
    y: 281.77,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-120"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1068.67,
    y: 281.77,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-121"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1374,
    y: 281.77,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-122"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 338.13,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-123"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 610.67,
    y: 338.13,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-124"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 305.33,
    y: 338.13,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-125"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 916,
    y: 338.13,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-126"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1221.34,
    y: 338.13,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-127"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 152.67,
    y: 338.13,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-128"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 763.34,
    y: 338.13,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-129"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 458,
    y: 338.13,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-130"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1068.67,
    y: 338.13,
    width: 37,
    height: 37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-131"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1374,
    y: 338.13,
    width: 37,
    height: 37
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-43"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.6,23.7a4.07,4.07,0,0,1-3.89.42c-3.17-1.06-6.2-4.56-7.2-8.29a1.73,1.73,0,0,1,.38-1.65c.91-1,3.17-1.58,5.93-1.6h.3a22.54,22.54,0,0,1,2.89.2,4.42,4.42,0,0,1,3.51,3.52c.72,2.75-.13,6-1.92,7.4M17,15.06a3.13,3.13,0,0,0-.81-1.87,4.29,4.29,0,0,0-.72-.61h6a4.65,4.65,0,0,0-.71.61A3.11,3.11,0,0,0,20,15.06a4.34,4.34,0,0,0-3,0m-1.53.75c-1,3.75-4,7.25-7.2,8.31A4.1,4.1,0,0,1,4.4,23.7c-1.79-1.41-2.64-4.65-1.92-7.4A4.42,4.42,0,0,1,6,12.78a22.57,22.57,0,0,1,2.9-.2h.31c2.76,0,5,.6,5.92,1.6a1.7,1.7,0,0,1,.38,1.63M36,15.93a5.82,5.82,0,0,0-4.73-4.62,25.5,25.5,0,0,0-3.1-.2H8.88a23.63,23.63,0,0,0-3.11.21,5.8,5.8,0,0,0-4.72,4.61c-.87,3.32.18,7.17,2.44,8.93a4.94,4.94,0,0,0,3.11,1,6.83,6.83,0,0,0,2.16-.38c3.4-1.14,6.64-4.69,8-8.62a3,3,0,0,1,3.58,0c1.3,3.92,4.54,7.48,8,8.62a6.79,6.79,0,0,0,2.16.38,4.94,4.94,0,0,0,3.11-1c2.26-1.76,3.31-5.61,2.44-8.93"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagePlaceholder);
export default __webpack_public_path__ + "static/media/image_placeholder.fc3d6c472df9963445ae640e8d4858ce.svg";
export { ForwardRef as ReactComponent };